/* ═══════════════════════════════════════════════════
   APP.JS — Updated with Firebase Auth
   File: src/App.js (REPLACE existing)
   
   Changes from previous version:
   - Wrapped in AuthProvider
   - Added /login and /signup routes
   - Dashboard now requires authentication
═══════════════════════════════════════════════════ */

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./utils/AuthContext";
import Navbar from "./components/Navbar/Navbar";
import Preloader from "./components/Preloader/Preloader";
import Landing from "./components/Landing/Landing";
import CareerTest from "./components/CareerTest/CareerTest";
import Results from "./components/Results/Results";
import CareerLibrary from "./components/CareerLibrary/CareerLibrary";
import CareerDetail from "./components/CareerLibrary/CareerDetail";
import StreamGuide from "./components/StreamGuide/StreamGuide";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import Footer from "./components/Footer/Footer";
import "./styles/global.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Preloader loading={loading} />
        <div style={{ minHeight: "100vh", position: "relative" }}>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/test" element={<CareerTest />} />
            <Route path="/results" element={<Results />} />
            <Route path="/careers" element={<CareerLibrary />} />
            <Route path="/careers/:careerId" element={<CareerDetail />} />
            <Route path="/streams" element={<StreamGuide />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
